import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { TikTokPrivacyLevelOptionName } from 'redux/middleware/api/third-party-authentication-service/types';
import { tikTokPostStatusSelector, tiktokSelector } from 'redux/modules/social';
import { PostStatus } from 'redux/modules/social/constants';
import { TikTokUserAllowance } from './types';
import { formatCaptions } from './utils';

export interface UseTikTokPostModalSelectorConfig {
  defaultCaptions?: string;
  defaultPrivacyLevel?: TikTokPrivacyLevelOptionName;
  defaultUserAllowance?: TikTokUserAllowance[];
  defaultBrandContent?: boolean;
  defaultBrandOrganic?: boolean;
  postStatus?: PostStatus;
}

const usernameSelector = createSelector(
  tiktokSelector,
  tikTok => tikTok.username,
);

const avatarSrcSelector = createSelector(
  tiktokSelector,
  tikTok => tikTok.profileImageUrl,
);

export default function useTikTokPostModalSelector(
  config: UseTikTokPostModalSelectorConfig = {},
) {
  const username = useSelector(usernameSelector);
  const avatarSrc = useSelector(avatarSrcSelector);
  const postStatus = useSelector(tikTokPostStatusSelector);

  const {
    defaultCaptions,
    defaultPrivacyLevel,
    defaultUserAllowance,
    defaultBrandContent,
    defaultBrandOrganic,
  } = config;

  return {
    username,
    avatarSrc,
    defaultCaptions: formatCaptions(defaultCaptions),
    defaultPrivacyLevel,
    defaultUserAllowance,
    defaultBrandContent,
    defaultBrandOrganic,
    postStatus,
  };
}
